import { CHECK_CIRCLE_V2, CLOCK_ICON, FLAG_BANNER_ICON } from './images';
import { IButtonImageV3 } from '../interfaces/button';
import { IChallengeDetail, IChallenge } from '../interfaces/challenges';
import { TRANSLATION_CHALLENGES } from '../translations/challenges';
import { BdsLabelPillVariant, CreateChallengeSteps } from '../types/types';

export const DEFAULT_CHALLENGE: IChallengeDetail = {
  id: '',
  name: '',
  description: '',
  participants: -1,
  status: '',
  startAt: '',
  endAt: '',
  unit: '',
  type: '',
  author: '',
  iconUrl: '',
  pictogram: '',
  participantsPercentageOverAverage: -1,
  leaderboard: []
};

export const CHALLENGE_DEFAULT_VALUES: IChallenge = {
  id: '',
  name: '',
  goal: 0,
  description: '',
  startAt: '',
  endAt: '',
  type: ''
};

export const CHALLENGES_TOTAL_STEPS = 5;
export const CREATE_CHALLENGE_FINAL_STEP = 4;
export const CREATE_CHALLENGE_SKELETON_COUNT = 6;

export const HERO_DESCRIPTIONS: Record<CreateChallengeSteps, string> = {
  0: TRANSLATION_CHALLENGES.hero.createChallenge.description,
  1: TRANSLATION_CHALLENGES.hero.selectChallengeDates.description,
  2: TRANSLATION_CHALLENGES.hero.descriptionChallenge.description,
  3: TRANSLATION_CHALLENGES.hero.challengeGoal.description,
  4: TRANSLATION_CHALLENGES.hero.challengeReview.description
};

export const CHALLENGES_STATUS: {
  [key: string]: { tagVariant: BdsLabelPillVariant; icon: IButtonImageV3 };
} = {
  active: { tagVariant: 'success', icon: CHECK_CIRCLE_V2 },
  finished: { tagVariant: 'inactive', icon: FLAG_BANNER_ICON },
  ready: { tagVariant: 'info', icon: CLOCK_ICON }
};

export const CHALLENGE_LEADERBOARD_PAGE_SIZE = 50;
